import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='mt-14 text-5xl font-semibold'>404: <span className='text-red-700'>Page Not Found</span></h1>
        </div>
    );
};

export default NotFound;